import { render, staticRenderFns } from "./Lgas.vue?vue&type=template&id=53b3ec6b&scoped=true"
import script from "./Lgas.vue?vue&type=script&lang=js"
export * from "./Lgas.vue?vue&type=script&lang=js"
import style0 from "./Lgas.vue?vue&type=style&index=0&id=53b3ec6b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53b3ec6b",
  null
  
)

export default component.exports